var escape = require("../../node_modules/css-loader/lib/url/escape.js");
exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".page-forgot,.page-login,.page-signup{background-image:url(" + escape(require("../assets/images/background/loginBackground.png")) + ");background-size:cover;height:100%}.page-forgot .logo img,.page-login .logo img,.page-signup .logo img{width:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ../node_modules/css-loader!../node_modules/sass-loader/lib/loader.js!./styles/login.scss
// module id = 2157
// module chunks = 43